import { Injectable } from '@angular/core';
import { FINANCIALGROUP } from 'app/model/financialgroup.model';
import { SharedPdfService } from 'app/services/shared/shared-pdf.service';

@Injectable()
export class FINANCIALService {
  constructor(private sharedPDFService:SharedPdfService) {}

  generateFinancial(financialGroup: FINANCIALGROUP) {
    return {
      style: 'tableExample',
      table: {
        widths: ['50%', '25%', '25%'],
        body: [
          [
            {
              text:
                'If applying for a credit account this section must be completed. A copy of your most recent financial statements is also required to be attached to this application',
              colSpan: 3,
              style: 'questions'
            },
            '',
            ''
          ],
          [
            {
              text: 'Est. Current Year Business Turnover Per Annum :',
              style: 'questions'
            },
            {
              colSpan: 2,
              text: 'Est. Value Of Current Assets :',
              style: 'questions'
            },
            ''
          ],

          [
            {
              text:
                ' ' + this.sharedPDFService.commaPipe(financialGroup.in_current_year_turnover),
              italics: true
            },
            {
              colSpan: 2,
              text: ' ' + this.sharedPDFService.commaPipe(financialGroup.in_current_assets),
              italics: true
            },
            ''
          ],
          [
            {
              text: 'Previous Year Business Turnover Per Annum:',
              style: 'questions'
            },
            {
              colSpan: 2,
              text: 'Est. Value of Current Liabilities:',
              style: 'questions'
            },
            ''
          ],

          [
            {
              text: ' ' + this.sharedPDFService.commaPipe(financialGroup.in_last_year_turnover),
              italics: true
            },
            {
              colSpan: 2,
              text: ' ' + this.sharedPDFService.commaPipe(financialGroup.in_current_liabilities),
              italics: true
            },
            ''
          ],
          [
            { text: 'Paid Up Capital:', style: 'questions' },
            {
              colSpan: 2,
              text:
                'If Any Registered Encumbrances/Charges, Please Give Details:',
              style: 'questions'
            },
            ''
          ],

          [
            {
              text: ' ' + this.sharedPDFService.commaPipe(financialGroup.in_capital),
              italics: true
            },
            {
              colSpan: 2,
              text: ' ' + financialGroup.in_encumberance_charges,
              italics: true
            },
            ''
          ],
          [
            { text: 'No of Issued Shares:', style: 'questions' },
            { colSpan: 2, text: '' },
            ''
          ],

          [
            {
              text: '  ' + this.sharedPDFService.commaPipe(financialGroup.in_no_of_shares),
              italics: true
            },
            { colSpan: 2, text: ' ', italics: true },
            ''
          ]
          // ,
          // [
          //     { text: 'Have you or any of your directors ever been registered under any part of the Bankruptcy Act (1966), been under any special financial arrangements or had legal proceedings commenced against you or any of your directors for payment of debts?', colSpan: 3,style: "questions" }
          //     , '', ''
          // ],
          // [
          //     { text: '  Yes (attach all details to this application)',style: "questions"},
          //     {
          //         text: " "+ financialGroup.in_bankrupcyYes=='true'?"Yes":"", italics: true,colSpan: 2
          //     },''
          // ],
          // [
          //     {  text: 'No ',style: "questions" },
          //     {
          //         colSpan: 2, text: ''+ financialGroup.in_bankrupcyNo=='true'?"No":"", italics: true,

          //     },
          //     ''
          // ]
        ]
      }
    };
  }


}



// WEBPACK FOOTER //
// ./src/app/services/pdf/financialpdf.generation.ts